import type { Snapshot } from '../types';
import { SLOT_LAYOUT, normalizeEquipment } from '../lib/wow';
import { ItemSlot } from './ItemSlot';

interface Props {
  snapshot: Snapshot;
}

/**
 * The paperdoll: 2 columns of slot icons + a bottom row for weapons/ranged.
 * The character name/level/race/class used to live in a center "portrait"
 * block here, but that's already shown in the page Header; the duplicate
 * stole vertical space without earning it. Kept as a flat 2-column grid.
 */
export function PaperDoll({ snapshot }: Props) {
  // Defensive: some historical snapshots come through as sparse arrays instead
  // of slot-id-keyed objects. Normalize so `equip[id]` always works.
  const equip = normalizeEquipment(snapshot.equipment);
  const leftSlots = Object.entries(SLOT_LAYOUT)
    .filter(([_, l]) => l.col === 'left')
    .sort((a, b) => a[1].order - b[1].order);
  const rightSlots = Object.entries(SLOT_LAYOUT)
    .filter(([_, l]) => l.col === 'right')
    .sort((a, b) => a[1].order - b[1].order);
  const bottomSlots = Object.entries(SLOT_LAYOUT)
    .filter(([_, l]) => l.col === 'bottom')
    .sort((a, b) => a[1].order - b[1].order);

  return (
    <div className="paperdoll">
      <div className="paperdoll-col">
        {leftSlots.map(([id, l]) => (
          <ItemSlot key={id} slot={equip[id]} slotName={l.name} />
        ))}
      </div>
      <div className="paperdoll-col">
        {rightSlots.map(([id, l]) => (
          <ItemSlot key={id} slot={equip[id]} slotName={l.name} />
        ))}
      </div>
      <div className="paperdoll-bottom">
        {bottomSlots.map(([id, l]) => (
          <ItemSlot key={id} slot={equip[id]} slotName={l.name} />
        ))}
      </div>
    </div>
  );
}
